module.exports = __webpack_public_path__ + "img/Vector.7c066e9f.svg";